module.exports = __webpack_public_path__ + "img/1F60C.82353576.svg";